import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5205eb66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = { class: "reset-password__container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "reset-password__input-group" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "reset-password__input-group" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "reset-password__title" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "reset-password__title" }
const _hoisted_15 = { class: "reset-password__input-group" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = ["label", "placeholder"]
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_message = _resolveComponent("v-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.hasResetToken)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.isPasswordReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('Common.PasswordResetSuccessMessage')), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isPasswordReset)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_v_form, { onSubmit: _ctx.onSubmitChangePassword }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_field, {
                          name: "emailAddress",
                          type: "hidden",
                          class: "input form-control",
                          modelValue: _ctx.emailAddress,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailAddress) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Common.NewPassword")), 1),
                        _createVNode(_component_v_field, {
                          name: "password",
                          type: "password",
                          class: "input form-control",
                          modelValue: _ctx.password,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Common.NewPasswordRepeat")), 1),
                        _createVNode(_component_v_field, {
                          name: "passwordRepeat",
                          type: "password",
                          class: "input form-control",
                          modelValue: _ctx.passwordRepeat,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.passwordRepeat) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createVNode(_component_BaseButton, {
                        class: "button--primary button--base",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Common.ChangePassword')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.hasResetToken)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.isEmailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Common.PasswordResetEmailSentMessage')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Common.ResetPassword')), 1)
                  ]),
                  _createVNode(_component_v_form, {
                    onSubmit: _ctx.onSubmit,
                    class: "reset-password__form-container"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailAddress) = $event)),
                          name: "emailAddress",
                          class: "input form-control",
                          rules: "required|email",
                          label: _ctx.$t('Common.EmailAddress'),
                          placeholder: _ctx.$t("ContactForm.EmailPlaceholder")
                        }, null, 8, _hoisted_17), [
                          [_vModelText, _ctx.emailAddress]
                        ]),
                        _createVNode(_component_v_message, { name: "emailAddress" })
                      ]),
                      _createVNode(_component_BaseButton, {
                        class: "button--primary button--base",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Common.ResetPassword')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("p", {
        class: "error-message",
        innerHTML: _ctx.errorMessage
      }, null, 8, _hoisted_18), [
        [_vShow, _ctx.hasError]
      ])
    ])
  ]))
}